import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import "./header.css";

export default class Header extends Component {
	constructor() {
      super();
			this.state={mobileHeader:false};

  }
	toggleMobileHeader = () =>{
		if(this.state.mobileHeader){
			this.setState({mobileHeader:false})
		}
		else{
			this.setState({mobileHeader:true})
		}
	}
	render() {
		return (
      <div id="header" className="header-background">
				<div className="mobile-menu-toggle" onClick={this.toggleMobileHeader}>
					<img className="full-width" src="/images/menu-icon.png" />
				</div>
        <div className="logo-container">
          <NavLink className="logo" exact to="/" activeClassName="active">
						<img style={{width: "100%"}} src="/images/logo.png" />
          </NavLink>
        </div>
				<div className="menu">
					<Link className="nav-link" to="/" activeClassName="active">
						<div className="menu-item uppercase">
							Home
						</div>
					</Link>
					<NavLink className="nav-link" to="/online" activeClassName="active">
						<div className="menu-item uppercase">
							Online Options
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/services" activeClassName="active">
						<div className="menu-item uppercase">
							Services & Rates
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/posture" activeClassName="active">
						<div className="menu-item uppercase">
							Posture
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/formoms" activeClassName="active">
						<div className="menu-item uppercase">
							For Moms
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/about" activeClassName="active">
						<div className="menu-item uppercase">
							About
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/videos" activeClassName="active">
						<div className="menu-item uppercase">
							Videos
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/testimonials" activeClassName="active">
						<div className="menu-item uppercase">
							Testimonials
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/contact" activeClassName="active">
						<div className="menu-item uppercase button">
							Contact Us
						</div>
					</NavLink>
				</div>
				{this.state.mobileHeader &&
					<div id="mobile-header" className="primary-background">
						<div id="mobile-menu-close" onClick={this.toggleMobileHeader}>
							<img style={{width: "30px"}} src="/images/close-icon.png" />
						</div>
						<div className="small-padding centered-text">
							<NavLink className="nav-link" to="/" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Home
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/online" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Online Options
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/services" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Studio Services & Rates
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/posture" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Posture
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/formoms" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									For Moms
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/about" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									About
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/videos" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Videos
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/testimonials" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Testimonials
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/contact" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Schedule
								</div>
							</NavLink>
						</div>
		      </div>
				}
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/header/index.js